/**
 * Global API Interceptor - Zero Code Changes Required
 * This wraps your existing apiClient to add enhanced AppDynamics error logging
 */

import { logger } from './logger';

import { logDetailedError } from "./EnhancedErrorLogging";
import store from "../store";
import { getLocalTimestamp } from "../api/apiClient";

// Initialize the global interceptor
export const initializeGlobalApiInterceptor = () => {
  // Enhance the existing reportError function in your apiClient.ts
  const originalConsoleError = logger.error;

  logger.error = (...args) => {
    // Call original logger.error
    originalConsoleError(...args);

    // Enhanced error logging for API errors
    try {
      const errorMessage =
        args.find((arg) => typeof arg === "string") || "Unknown error";
      const errorObject = args.find((arg) => arg instanceof Error);

      if (
        errorMessage.includes("API Error:") ||
        errorMessage.includes("Token refresh failed:")
      ) {
        const state = store.getState();
        const currentScreen = getCurrentScreenFromState(state);

        logDetailedError(errorObject || errorMessage, {
          severity: "ERROR",
          component: "APIClient",
          screen: currentScreen,
          action: "api_error",
          capturedByInterceptor: true,
          timestamp:getLocalTimestamp(),
        });
      }
    } catch (interceptorError) {
      originalConsoleError("Global interceptor error:", interceptorError);
    }
  };

  logger.log(
    "🔍 Global API interceptor initialized - enhanced error logging active"
  );
};

// Helper function to determine current screen from Redux state
const getCurrentScreenFromState = (state: any): string => {
  // Try to infer from navigation state, active tab, or other state indicators
  if (state.navigation?.currentRoute) {
    return state.navigation.currentRoute;
  }

  // Try to infer from URL path
  if (typeof window !== "undefined" && window.location) {
    const path = window.location.pathname;
    if (path.includes("leadership")) return "LeadershipWalk";
    if (path.includes("shift")) return "ShiftHandover";
    if (path.includes("observation")) return "Observation";
    if (path.includes("racking")) return "RackingInspection";
    if (path.includes("sparc")) return "SparcWalk";
    if (path.includes("pulse")) return "PulseCheck";
    if (path.includes("nho")) return "NewHireOnboarding";
  }

  return "Unknown";
};

export default initializeGlobalApiInterceptor;
